export default "__VITE_ASSET__Cdfye$WA__"